/**
 * GENERATED ADAPTATION by scripts/sync-home.sh — DO NOT EDIT.
 *
 * Minimal stand-in for the Console's "Work with me" module (canonical:
 * tc-console/src/home/workWithMe.ts), which Phase 2 deliberately does NOT vendor —
 * the assistant bridge it feeds is Phase 3 for Learner Views. The vendored
 * HomeSurface imports PICK_ATTR / pickFromElement / picksInRect /
 * composeWorkWithMe, so this shim keeps those exact signatures (and the same
 * data-attribute picking behavior, which the pick-mode outlines also rely on)
 * to let the renderer compile and run untouched. Phase 3 replaces this file
 * with the real vendored module.
 */

export interface WorkWithMePick {
  kind: string
  label: string
  detail?: string
  target?: string
}

const MAX_DETAIL = 400
const MAX_ITEMS = 8

export const PICK_ATTR = 'data-home-pick'

export function pickFromElement(el: Element): WorkWithMePick | null {
  const kind = el.getAttribute(PICK_ATTR)
  const label = el.getAttribute('data-home-label')
  if (!kind || !label) return null
  const detail = el.getAttribute('data-home-detail') ?? undefined
  const target = el.getAttribute('data-home-target') ?? undefined
  return { kind, label, detail: detail?.slice(0, MAX_DETAIL), target }
}

export function picksInRect(root: HTMLElement, rect: DOMRect | { left: number; top: number; right: number; bottom: number }): WorkWithMePick[] {
  const hits: Element[] = []
  for (const el of Array.from(root.querySelectorAll(`[${PICK_ATTR}]`))) {
    const r = el.getBoundingClientRect()
    const overlaps = r.right > rect.left && r.left < rect.right && r.bottom > rect.top && r.top < rect.bottom
    if (!overlaps) continue
    if (hits.some((h) => h.contains(el))) continue
    for (let i = hits.length - 1; i >= 0; i -= 1) if (el.contains(hits[i])) hits.splice(i, 1)
    hits.push(el)
  }
  return hits.map(pickFromElement).filter((p): p is WorkWithMePick => !!p).slice(0, MAX_ITEMS)
}

function line(p: WorkWithMePick): string {
  const bits = [`(${p.kind}) ${p.label}`]
  if (p.detail) bits.push(p.detail)
  if (p.target && /^https?:/.test(p.target)) bits.push(p.target)
  return `- ${bits.join(' — ')}`
}

export function composeWorkWithMe(picks: WorkWithMePick[]): string | null {
  if (!picks.length) return null
  if (picks.length === 1) {
    const p = picks[0]
    const lines = ['[Work with me — Home] What is this? Tell me about it.', '', `Selected (${p.kind}): ${p.label}`]
    if (p.detail) lines.push(p.detail)
    if (p.target && /^https?:/.test(p.target)) lines.push(`Link: ${p.target}`)
    return lines.join('\n')
  }
  return [
    "[Work with me — Home] I've lassoed this — expand on it.",
    '',
    `Selected ${picks.length} things on Home:`,
    ...picks.map(line),
  ].join('\n')
}
